import { useLayoutEffect, useRef } from 'react';

export const measureMaxCtaWidth = (container: HTMLElement): number => {
	const buttons = Array.from(container.querySelectorAll<HTMLElement>('[data-cta-button]'));
	return buttons.reduce((acc, btn) => Math.max(acc, btn.offsetWidth), 0);
};

export const useSyncedCtaWidth = (tasks: readonly unknown[]) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const container = containerRef.current;
		if (!container) return;
		const buttons = Array.from(container.querySelectorAll<HTMLElement>('[data-cta-button]'));
		const width = measureMaxCtaWidth(container);
		for (const btn of buttons) btn.style.minWidth = width ? `${width}px` : '';
	}, [tasks]);

	return containerRef;
};
